import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LoginView from '../views/LoginView.vue'

Vue.use(VueRouter)

const routes = [
  {
    // 路由重定向
    path: '/',
    redirect: '/home'
  },
  {
    // 主界面
    path: '/home',
    name: 'homepage',
    component: HomeView
  },
  {
    // 登录界面
    path: '/login',
    name: 'loginpage',
    component: LoginView
  }
]

const router = new VueRouter({
  routes
})

// // 前置路由守卫
// router.beforeEach((to, from, next) => {
//   // 如果是登录页不做限制
//   if (to.path === '/login') return next()

//   // 如果没有token强制跳转至登录页
//   const token = window.sessionStorage.getItem('token')
//   if (!token) return next('/login')
//   next()
// })

export default router
